<template>
  <div class="wrapper_dark" @click="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("select_person") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>
    <div class="inner_wrap">
      <div class="danger_box">
        <div class="title">{{ $tc("order_number") }}</div>
        <div class="text" v-html="$tc('seats_available')"></div>
      </div>
      <div class="person-select-wrap">
        <div class="item">
          <div class="title">
            {{ isChild ? adultLabel : $tc("total_number") }}
          </div>
          <div class="sel_box">
            <button
              class="minus"
              :class="{ disabled: adultPerson <= minAdultPerson }"
              @click="personCount('decrease', 'adultPerson')"
            ></button>
            <div class="count">{{ adultPerson }}</div>
            <button
              class="plus"
              @click="personCount('increase', 'adultPerson')"
            ></button>
          </div>
        </div>
        <div v-if="isChild" class="item">
          <div class="title">
            {{ childLabel }}
            <span v-if="babyAgeText.text">{{ babyAgeText.text }}</span>
          </div>
          <div class="sel_box">
            <button
              class="minus"
              :class="{ disabled: childPerson <= 0 }"
              @click="personCount('decrease', 'childPerson')"
            ></button>
            <div class="count">{{ childPerson }}</div>
            <button
              class="plus"
              @click="personCount('increase', 'childPerson')"
            ></button>
          </div>
        </div>
      </div>
      <button class="next_btn" :class="{ active: isActive }" @click="next">
        {{ $tc("next") }}
      </button>
    </div>
    <Popup v-show="showPopup" @popControl="popup" />
    <AlertPopup v-if="isAlert" :msg="msg" @AlertEvent="alertAction" />
    <timeout-popup
      :isShow="isShowTimeOutPop"
      @moveToHome="moveToHome"
      @close="closeTimeoutPopup"
    />
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import { viewport } from './mixins/viewport'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import Popup from '@/components/Popup.vue'
import AlertPopup from '@/components/AlertPopup'
import { getCustomPersonLabel, getCustomMaxPersonMsg } from '../utills'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'SelectPerson',
  mixins: [timeout, viewport],
  components: {
    timeoutPopup,
    Popup,
    AlertPopup
  },
  data () {
    return {
      isShowTimeOutPop: false,
      timeoutObj: null,
      adultPerson: 1,
      childPerson: 0,
      isActive: true,
      showPopup: false,
      msg: '',
      isAlert: false
    }
  },
  computed: {
    ...mapState(['locale']),
    ...mapGetters({
      restaurant: 'getRestaurantInfo',
      waitingParams: 'getWaitingParams'
    }),
    isChild () {
      return this.restaurant.isChildOption
    },
    isMenuReuired () {
      return this.restaurant.menuRequired
    },
    maxPeople () {
      return this.restaurant.maxPeople
    },
    storeIdx () {
      return this.$store.getters.getStoreIdx
    },
    // 특정 매장은 성인/유아 명칭을 커스텀 텍스트로 표기 (TB-14228, TB-14471)
    customPersonLabel () {
      return getCustomPersonLabel(this.storeIdx)
    },
    adultLabel () {
      return this.customPersonLabel ? this.customPersonLabel.adult : this.$tc('adult')
    },
    // 특정 매장은 최소 인원 2명부터 선택 가능 (TB-14470, 김삿갓밥집 사례)
    minAdultPerson () {
      return (process.env.VUE_APP_MIN_TWO_PERSON && process.env.VUE_APP_MIN_TWO_PERSON.includes(this.storeIdx)) ? 2 : 0
    },
    childLabel () {
      return this.customPersonLabel ? this.customPersonLabel.child : this.$tc('child')
    },
    babyAgeText () {
      // 로마경양식(8899)만 아이 나이 안내 표기 (TB-7701)
      // dev: 추가로 22도 표기 (테스트용)
      // dev, staging: 샤토브리앙(51530) 도 추가 (테스트용)
      // production: 505 추가 (테스트용))
      const result = {
        use: false,
        text: ''
      }
      switch (process.env.VUE_APP_STEP) {
        case 'dev':
          switch (this.storeIdx) {
            case '22': // BBQ 치킨 이대점 2 (22)
            case '51530': // 샤토브리앙 (FE) (51530)
              result.use = true
              result.text = '(4세미만)'
              break
            default:
              break
          }
          break
        case 'sta':
          switch (this.storeIdx) {
            case '51530': // 샤토브리앙 (FE) (51530)
            case '51975': // QA 테스트 매장 (51975)
              result.use = true
              result.text = '(4세미만)'
              break
            default:
              break
          }
          break
        case 'pro': {
          switch (this.storeIdx) {
            case '505': // [TEST] 밀랑 (505)
            case '9146': // 샤브올데이 용인상현점 (9149)
              result.use = true
              result.text = '(10세 미만)'
              break
            default:
              break
          }
          break
        }
      }
      return result
    }
  },
  watch: {
    adultPerson () {
      this.checkActive()
    },
    childPerson () {
      this.checkActive()
    }
  },
  methods: {
    checkActive () {
      if (this.restaurant.useLimitForWaiting) {
        this.isActive =
          this.adultPerson > 0 &&
          this.maxPeople >= this.adultPerson + this.childPerson
      } else {
        this.isActive = this.adultPerson > 0
      }
    },
    personCount (type, target) {
      if (type === 'increase') {
        if (
          this.maxPeople !== 0 &&
          this.maxPeople - 1 < this.adultPerson + this.childPerson
        ) {
          this.isAlert = true
          // TB-14651: 다담석갈비(9427) - 최대인원수 초과접수시 안내문구 변경 필요
          const customMaxPersonMsg = getCustomMaxPersonMsg(this.storeIdx)
          if (customMaxPersonMsg) {
            this.msg = customMaxPersonMsg
            return
          }
          if (process.env.VUE_APP_APM_ENVIRONMENT === 'production') {
            // 운영일 경우만 동작
            // TB-1311: 최대인원수 초과하여 접수시 매장에 따라 안내문구 변경이 필요
            if (
              this.storeIdx &&
              ['8821', '3860'].includes(this.storeIdx.toString())
            ) {
              this.msg = `${this.maxPeople * 1 +
                1}명 이상은 2팀으로 나눠서 대기접수 해주세요.`
              // TB-4835: [FE][테이블링접수] 6466 홍원막국수 - 최대인원수 초과접수시 안내문구 변경 필요
            } else if (
              this.storeIdx &&
              ['6466'].includes(this.storeIdx.toString())
            ) {
              this.msg =
                '최대 대기등록인원은 8인입니다.<div style="margin-top:10px">(예) 12명일경우. 8명 4명<br/>또는 4명씩 3팀으로 나눠서<br/>예약하세요 (전화번호도 각각)</div>'
            } else if (
              this.storeIdx &&
              ['10118'].includes(this.storeIdx.toString())
            ) {
              // [TB-5126] [FE][테이블링접수] 10118 진주냉면 대연본점 - 최대인원수 초과접수시 안내문구 변경 필요
              this.msg =
                '6인 이상고객님들은 최대 4인씩 나눠서 등록 부탁드립니다. 그리고 인원이 모두 도착하신 후 등록부탁드립니다.<div style="margin-top:10px">ex) 7인일경우 4인/3인 나눠서 등록부탁드립니다.</div>'
            } else if (
              this.storeIdx &&
              ['4608'].includes(this.storeIdx.toString())
            ) {
              // [TB-9370] [FE][테이블링대기] 인원 수 제안 팝업 문구 수정 - 꼼다비뛰드(4608)
              this.msg = '주문하실 인원 수에 맞게 각자 웨이팅 부탁드립니다.'
            } else if (
              this.storeIdx &&
              [
                '12547',
                '12548',
                '12551',
                '12549',
                '12550',
                '12803',
                '12804'
              ].includes(this.storeIdx.toString())
            ) {
              // [TB-10455] [FE][접수/호출] 특정매장 대상 인원 선택 초과 시 팝업 텍스트 변경 - 유니클로
              this.msg = '1명만 신청 가능합니다.'
            } else if (
              this.storeIdx &&
              ['8900'].includes(this.storeIdx.toString())
            ) {
              // [TB-10734] [FE][테이블링접수] 8900 능동미나리 - 최대인원수 초과접수시 안내문구 변경 필요
              this.msg = `${this.maxPeople * 1 +
                1}명이상은 오른쪽 안내문 읽어주세요.`
            } else if (
              this.storeIdx &&
              ['6740'].includes(this.storeIdx.toString())
            ) {
              // [TB-10857] [FE][테이블링접수] 6740 신라제면 본점 - 최대인원수 초과접수시 안내문구 변경 필요
              // 6명 이상은 3명+3명/4명+2명 따로 대기등록 부탁드립니다. (대기 순번대로 한팀씩 입장합니다.)
              this.msg =
                '6명 이상은 3명+3명/4명+2명 따로 대기등록 부탁드립니다. (대기 순번대로 한팀씩 입장합니다.)'
            } else if (
              this.storeIdx &&
              ['4528'].includes(this.storeIdx.toString())
            ) {
              // [TB-12270] [FE][테이블링접수] 4528 델씨엘로 - 최대인원수 초과접수시 안내문구 변경 필요
              // 1. 모든 연령(영유아~100세)은 인원 수에 포함됩니다.
              // 2. 7인 부터는 2팀 이상으로 나누어 개별 입장이 가능합니다. (한 테이블에 의자 붙혀 앉기는 불가합니다.)
              this.msg =
                '1. 모든 연령(영유아~100세)은 인원 수에 포함됩니다.<br/>2. 7인 부터는 2팀 이상으로 나누어 개별 입장이 가능합니다.<br/>(한 테이블에 의자 붙혀 앉기는 불가합니다.)'
            } else {
              this.msg = this.$tc('ask_staff', this.maxPeople * 1 + 1)
            }
          } else {
            this.msg = this.$tc('ask_staff', this.maxPeople * 1 + 1)
          }
          return
        }
        this._data[target]++
      } else {
        const min = target === 'adultPerson' ? this.minAdultPerson : 0
        this._data[target] =
          this._data[target] > min ? this._data[target] - 1 : min
      }
    },
    next () {
      if (!this.isActive) {
        return
      }
      const params = {
        numOfPeople: this.adultPerson,
        childCount: this.childPerson
      }
      // this.$store.commit('waitingParams', params)
      this.$store.commit('setWaitingParams', params)
      // if ((this.restaurant.isCWType && this.restaurant.isRemoteWaitingOrderType && this.restaurant.isWType) && (this.isMenuReuired && !this.waitingParams.isNoPhone) && this.waitingParams.email === '') {
      if (
        this.restaurant.isWType &&
        this.isMenuReuired &&
        !this.waitingParams.isNoPhone &&
        this.waitingParams.email === '' &&
        this.waitingParams.tempKey === ''
      ) {
        this.$router.push('/menu')
      } else {
        this.$router.push('/confirm')
      }
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    },
    back () {
      let goPath = this.restaurant.nameRequired ? '/privacy' : '/phone'
      if (
        (!this.restaurant.nameRequired && !this.restaurant.phoneRequired) ||
        (this.restaurant.isNumTicket && this.locale !== 'ko')
      ) {
        goPath = '/'
      }
      if (
        this.locale !== 'ko' &&
        this.restaurant.foreignRequestType &&
        this.restaurant.foreignRequestType.length > 0 &&
        this.waitingParams.email
      ) {
        goPath = '/email'
      }
      // LINE 접수는 개인정보 입력 화면이 없으므로 접수 방법 선택으로 돌아간다
      if (
        this.locale !== 'ko' &&
        this.restaurant.foreignRequestType &&
        this.restaurant.foreignRequestType.length > 0 &&
        this.waitingParams.tempKey
      ) {
        goPath = '/bifurcation'
      }
      this.$router.push(goPath)
    },
    alertAction (type) {
      if (type === 'close') {
        this.isAlert = false
      }
    }
  },
  mounted () {
    this.adultPerson = Math.max(this.waitingParams.numOfPeople, this.minAdultPerson)
    this.childPerson = this.waitingParams.childCount
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";

.inner_wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.danger_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  @include flex-gap(16px, column);
  padding: vh(4.5) 0;
  .title {
    display: flex;
    align-items: center;
    color: #d81b1b;
    text-align: center;
    font-size: 32px; // IE11 fallback
    font-size: unquote("min(#{vh(4)}, 32px)");
    font-weight: 700;
    line-height: 1.125;
    &::before {
      content: "";
      display: block;
      width: vh(5);
      height: vh(5);
      margin-right: vh(1);
      background: url("~@/assets/img/caution.svg") no-repeat center center;
    }
  }
  .text {
    color: #2e3137;
    text-align: center;
    font-size: 28px; // IE11 fallback
    font-size: unquote("min(#{vh(3.5)}, 28px)");
    font-weight: 600;
    line-height: 1.5;
  }
}
.person-select-wrap {
  display: flex;
  flex-direction: column;
  @include flex-gap(32px, column);
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: vh(100);
    padding: vh(2.5) vh(6.25);
    border-radius: vh(2.5);
    background: #eceef0;
    .title {
      display: flex;
      align-items: center;
      @include flex-gap(vh(1), row);
      color: #000000;
      font-size: 40px; // IE11 fallback
      font-size: unquote("min(#{vh(5)}, 40px)");
      font-weight: 700;
      line-height: 1.35;
      span {
        font-size: 28px; // IE11 fallback
        font-size: unquote("min(#{vh(3.5)}, 28px)");
        color: #6d7583;
      }
    }
    .sel_box {
      display: flex;
      align-items: center;
      @include flex-gap(vh(4), row);
      button {
        width: vh(8.75);
        height: vh(8.75);
        border-radius: vh(1.5);
        border: vh(0.125) solid #b7bec8;
      }
      .minus {
        background: url("~@/assets/img/minus.svg") no-repeat $white;
        background-size: vh(3.75) vh(0.625);
        background-position: center;
        &.disabled {
          background: url("../assets/img/minus-disabled.svg") no-repeat $white;
          background-position: center;
        }
      }
      .plus {
        background: url("~@/assets/img/plus.svg") no-repeat $white;
        background-size: vh(3.25) vh(3.25);
        background-position: center;
      }
      .count {
        width: vh(10);
        color: black;
        text-align: center;
        font-size: 40px; // IE11 fallback
        font-size: unquote("min(#{vh(5)}, 40px)");
        font-weight: 700;
        line-height: 1.35;
      }
    }
  }
}
.next_btn {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 94px;
  background: #b7bec8;
  color: rgba(255, 255, 255, 0.59);
  font-size: 36px; // IE11 fallback
  font-size: unquote("min(#{vh(4.5)}, 36px)");
  font-weight: 700;
  line-height: 1.055;
  &.active {
    cursor: pointer;
    color: #ffffff;
    background-color: #d81b1b;
  }
}
</style>
